import React from 'react';
import Lottie from 'lottie-react';
import animationData from '../assets/animations/dGRJdph16G.json'; // Ruta actualizada

const LottieAnimation = () => {
  return <Lottie animationData={animationData} loop={true} />;
};

export default LottieAnimation;
